import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

export const SkeletonEventRow: React.FC = () => (
  <LoadingStateWrapper className={styles.eventRow}>
    <Skeleton variant="rectangular" height="20px" width="300px" animation="pulse" />
    <Skeleton variant="rectangular" height="18px" width="18px" animation="pulse" />
  </LoadingStateWrapper>
);

export const SkeletonEventDividerText: React.FC = () => (
  <LoadingStateWrapper>
    <Skeleton variant="rectangular" height="18px" width="40px" animation="pulse" />
  </LoadingStateWrapper>
);
